/* eslint-disable react/display-name */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Card, CardBody, CardHeader, Col, Container, Row, UncontrolledTooltip, NavLink } from 'reactstrap';

import ReactTable, { ReactTableDefaults } from 'react-table';
import 'react-table/react-table.css';

import HttpUtil from '../../Util/httpUtil';
import Config from '../../Util/config';

import PesquisaRapida from '../Common/PesquisaRapida';
import PrettyCheckbox from '../Common/PrettyCheckbox';
import TooltippedCel from '../Common/TooltippedCel';

import { ModalUploadContext } from '../../Providers/ModalUpload';
import { AlertasContext } from '../../Providers/Alertas';
import { BlockUiContext } from '../../Providers/BlockUi';

import EmissoesErro from '../Modais/EmissoesErro';
import EmissoesExclusao from '../Modais/EmissoesExclusao';
import EmissoesExclusaoTodos from '../Modais/EmissoesExclusaoTodos';
import Pagination from '../../Util/Pagination';

import { getVal, formataCurrency, formataDataHora } from '../../BaseFunctions';

import './Rejeitadas.scss';

const isSimulacao = localStorage.getItem('isSimulacao') === 'true';
const isPro = localStorage.getItem('isPro') === 'true';

let pageSize = 20;

Object.assign(ReactTableDefaults, {
	pageSizeOptions: [20, 25, 50, 100],
	defaultPageSize: 20,
    pageSize: 20,
	minRows: 20,
	//maxRows: 30,
	nextText: 'Próxima',
	// previousText: 'Anterior',
	noDataText: 'Nenhum resultado encontrado',
	pageText: 'Pág.',
	ofText: 'de',
	rowsText: 'linhas',
});

function Rejeitadas() {
	const [rawData, setRawData] = useState([]);
	const [showData, setShowData] = useState([]);
	const [termoAceito, setTermoAceito] = useState(false);
	const [emissoesErro, setEmissoesErro] = useState({});
	const [strBusca, setStrBusca] = useState('');
	const [blFiltroAtivo, setBlFiltroAtivo] = useState(false);
	const [blShowPesquisaRapida, setBlShowPesquisaRapida] = useState(false);
	const [urlHomo, setUrlHomo] = useState("");
	const [pageData, setDataPage] = useState('');
	const [showDataPagination, setShowDataPagination] = useState([]);

	let reactTable = React.createRef();
	var ModalEmissoesErro = React.createRef();
	var ModalEmissoesExclusao = React.createRef();
	let ModalEmissoesExclusaoTodos = React.createRef();

	/* eslint-disable no-unused-vars */
	let onLoading;
	let showInfoMessage;
	let showSuccessMessage;
	let showWarningMessage;
	let showErrorMessage;
	let openModalUpload;
	/* eslint-enable no-unused-vars */

	useEffect(() => {
		verificaTermoDeUso();
		var notificar = localStorage.getItem('notificarEnvio');
		if (notificar === 'true') {
			showSuccessMessage('Arquivos enviados com sucesso!');
		}
		localStorage.setItem('notificarEnvio', false);

		handleReload();

		if (window.location.hostname == "ec2-34-206-89-100.compute-1.amazonaws.com") {
			setUrlHomo("http://www.testegnre.pe.gov.br/gnre/portal/GNRE_DisponibilidadeUF.jsp");
		} else {
			setUrlHomo("http://www.gnre.pe.gov.br:444/gnre/portal/GNRE_DisponibilidadeUF.jsp");
		}
	}, []);

	const verificaTermoDeUso = () => {
		var url = `${Config.urls.API_URL_BASE}Acesso/VerificaTermoDeUso`;

		return new Promise(() => {
			//TODO Precisa disso?
			HttpUtil.eco_GET(url).then(
				response => {
					setTermoAceito(response.data);
				},
				() => {
					window.location = '/erro';
				},
			);
		});
	};

	const handleReload = () => {
		onLoading(true);

		const primeiroAcesso =
			localStorage.getItem('PrimeiroAcesso') && localStorage.getItem('PrimeiroAcesso').toLowerCase() === 'true';

		HttpUtil.eco_GET(`${Config.urls.API_URL_BASE}Documento/BuscarRejeitadas`)
			.then(response => {
				onLoading(false);

				const { data } = response;

				if (termoAceito === true) {
					if (!data.length && window.location.pathname === '/' && !primeiroAcesso) openModalUpload();
				}

				const rawData = data.map(original => ({ ...original, blSelected: false }));
				setRawData(rawData);
				setShowData(rawData);
				setShowDataPagination(rawData);
			})
			.catch(() => {
				onLoading(false);
				showErrorMessage('Erro ao carregar dados');
				setRawData([]);
				setShowData([]);
			});
	};

	const onUpdatePesquisaRapida = (data, strBusca, blShow) => {
		setShowData(data);
		setStrBusca(strBusca);
		setBlShowPesquisaRapida(blShow);
	};

	const textFilterMethod = (filter, row) =>
		row[filter.id] && row[filter.id].toLowerCase().indexOf(filter.value.toLowerCase()) > -1;

	const dateFilterMethod = (filter, row) =>
	row[filter.id] && (new Date(row[filter.id]).toLocaleDateString()).indexOf(filter.value) > -1;

	const childPaginationValue = (page) => {
		setDataPage(page);
	}

	const handleTableSelectAllChange = ({ target: { checked } }) => {
		const firstPageIndex = (pageData - 1) * pageSize;
		const lastPageIndex = firstPageIndex + pageSize;

		const dadosLista = showData.slice(firstPageIndex, lastPageIndex);

		console.log('dadosList', dadosLista);

		let listaPaginada = dadosLista.map(original => ({ ...original, blSelected: checked }))

		const valor = rawData.map( row => {
			listaPaginada.map(el => {
				if (row.id == el.id){
					row.blSelected = el.blSelected;
				}
			});
			return row;
		});

		setShowDataPagination(valor);

		setShowDataPagination(valor.map(original => ({ ...original, blSelected: checked })));

		//setShowData(showData.map(original => ({ ...original, blSelected: checked })));
	};

	const handleTableSelectChange = (row, target) => {
		setShowData([
			...showData.slice(0, row.index),
			{ ...row.original, [target.name]: target.checked },
			...showData.slice(row.index + 1),
		]);
	};

	useEffect(() => {
		emissoesErro.strCodigoErro && ModalEmissoesErro.openModal();
	}, [emissoesErro]);

	const mostrarErrosTLote = id => {
		HttpUtil.eco_GET(`${Config.urls.API_URL_BASE}Documento/BuscarErrosTLoteGnre/` + id).then(response => {
			setEmissoesErro(response.data);
			console.log(response.data);
		});
	};

	const mostrarErrosItens = id => {
		HttpUtil.eco_GET(`${Config.urls.API_URL_BASE}Documento/BuscarErrosItensGnre/` + id).then(response => {
			setEmissoesErro(response.data);
		});
	};

	const renderDocumentosFiscais = row => {
		const listDocumentosFiscais = getVal(row, 'original.listDocumentosFiscais') || [];

		const columns = [
			{
				Header: () => <div className="text-left">N. DOCUMENTO</div>,
				accessor: 'strDocumento',
				className: 'text-left',
				width: 100,
				Cell: row => (row.value != null ? (row.value.length >= 35 ? parseInt(row.value.substring(25, 34)) : row.value) : ""),
			},
			{
				Header: () => <div className="text-left">TIPO</div>,
				accessor: 'strTipoNota',
				className: 'text-left',
				width: 50,
			},
			{
				Header: () => <div className="text-left">DESTINATÁRIO</div>,
				accessor: 'strDestinatario',
				className: 'text-left',
				Cell: row => <TooltippedCel text={row.value} />,
			},
			{
				Header: 'RECEITA',
				accessor: 'strReceita',
				className: 'text-center',
				width: 80,
			},
			{
				Header: 'FCP',
				accessor: 'receitaFcp',
				className: 'text-center',
				width: 60,
				Cell: row => {
					const infoFCP_id = `info-fcp-id-${new Date().getTime()}`;

					return (
						<div>
							{row.value}
							{row.original.receitaFcp === 'Não' && row.original.vlFcp > 0 ? (
								<span>
									&nbsp;
									<i id={infoFCP_id} className="fas fa-info-circle text-info" />
									<UncontrolledTooltip placement="right" target={infoFCP_id}>
										A guia de FCP deverá ser emitida diretamente no Portal da SEFAZ, relativo ao
										estado
									</UncontrolledTooltip>
								</span>
							) : null}
						</div>
					);
				},
			},
			{
				Header: 'PRINCIPAL',
				accessor: 'vlPrincipal',
				className: 'text-center',
				Cell: row => formataCurrency(row.value),
				width: 100,
			},
			{
				Header: 'MULTA',
				accessor: 'vlMulta',
				className: 'text-center',
				Cell: row => formataCurrency(row.value),
				width: 100,
			},
			{
				Header: 'JUROS',
				accessor: 'vlJuros',
				className: 'text-center',
				Cell: row => formataCurrency(row.value),
				width: 100,
			},
			{
				Header: 'VALOR TOTAL',
				accessor: 'vlTotal',
				className: 'text-center',
				Cell: row => formataCurrency(row.value),
				width: 150,
			},
			{
				Header: 'INFORMAÇÕES',
				accessor: 'blItemGnreErro',
				className: 'text-center',
				filterable: false,
				width: 120,
				Cell: row =>
					row.original.blItemGnreErro ? (
						<i className="fas fa-exclamation-circle" onClick={() => mostrarErrosItens(row.original.id)} />
					) : (
						<i />
					),
			},
		];

		return (
			<Card className="documentos-fiscais">
				<CardHeader>DOCUMENTOS FISCAIS</CardHeader>
				<CardBody>
					<ReactTable
						data={listDocumentosFiscais}
						filterable={false}
						columns={columns}
						showPagination={false}
						defaultSorted={[{ id: 'blItemGnreErro', desc: true }]}
						minRows={1}
					/>
				</CardBody>
			</Card>
		);
	};

	const necessitaDetalhes = documento =>
		(documento.listProduto && documento.listProduto.length && !documento.codigoProduto) ||
		(documento.listDetalhamento && documento.listDetalhamento.length && !documento.codigoDetalhamento);

	const mostrarDestacados = (row, valor, tooltip = false) => {
		return (
			<div style={necessitaDetalhes(row.original) ? { color: '#f58314', fontWeight: 'bold' } : {}}>
				{tooltip ? <TooltippedCel text={valor} /> : valor}
			</div>
		);
	};

	const columns = [
		{
			Header: () => <div />,
			expander: true,
			// eslint-disable-next-line react/prop-types
			Expander: ({ isExpanded }) => (
				<div>{isExpanded ? <i className="fas fa-minus" /> : <i className="fas fa-plus" />}</div>
			),
		},
		{
			Header: () => (
				<PrettyCheckbox
					strTitle="Essa opção seleciona todos os documentos existentes nesse grupo e não somente a quantidade exibida."
					checked={showDataPagination.every(original => original.blSelected)}
					id="selectAll"
					onChange={e => handleTableSelectAllChange(e)}
					iconSuccess="fas fa-check-double"
					simpleSelection
				/>
			),
			accessor: 'blSelected',
			Cell: row => (
				<PrettyCheckbox
					strTitle="Selecionar"
					checked={row.original.blSelected}
					id="blSelected"
					onChange={({ target }) => handleTableSelectChange(row, target)}
					iconSuccess="fas fa-check"
					simpleSelection
				/>
			),
			filterable: false,
			sortable: false,
			className: 'text-center',
			width: 35,
		},
		{
			Header: () => <div className="text-left">Emitente</div>,
			accessor: 'razaoSocialEmissor',
			filterMethod: textFilterMethod,
			className: 'text-left',
			Cell: row => mostrarDestacados(row, row.value, false),
		},
		{
			Header: 'Data de envio',
			accessor: 'data',
			filterMethod: dateFilterMethod,
			className: 'text-center',
			width: 200,
			Cell: row => mostrarDestacados(row, formataDataHora(row.value), false),
		},
		{
			Header: 'UF',
			accessor: 'uf',
			filterMethod: textFilterMethod,
			className: 'text-center',
			width: 50,
		},
		{
			Header: () => <div className="text-right">Valor total</div>,
			accessor: 'valorTotal',
			filterMethod: (filter, row) => row[filter.id] && row[filter.id].toString().includes(filter.value),
			className: 'text-right',
			width: 100,
			Cell: row => mostrarDestacados(row, formataCurrency(row.value)),
		},
		{
			Header: 'Informações',
			accessor: 'blGnreErro',
			className: 'text-center',
			filterable: false,
			width: 120,
			Cell: row =>
				row.original.blGnreErro ? (
					<i className="fas fa-exclamation-circle" onClick={() => mostrarErrosTLote(row.original.id)} />
				) : (
					<i />
				),
		},
	];

	return (
		<main id="rejeitadas">
			<EmissoesErro ref={modal => (ModalEmissoesErro = modal)} value={emissoesErro} onClosed={handleReload} />
			<EmissoesExclusao
				ref={ModalEmissoesExclusao}
				value={showData.filter(x => x.blSelected).map(x => x.id)}
				onClosed={handleReload}
			/>
			<EmissoesExclusaoTodos
				ref={ModalEmissoesExclusaoTodos}
				value={showData.map(x => x.id)}
				status={3}
				onClosed={handleReload}
			/>
			<ModalUploadContext.Consumer>
				{modalUpload => {
					openModalUpload = modalUpload.openModal;
					modalUpload.onClosed = handleReload;
				}}
			</ModalUploadContext.Consumer>
			<AlertasContext.Consumer>
				{alertas => {
					showInfoMessage = alertas.info;
					showSuccessMessage = alertas.success;
					showWarningMessage = alertas.warning;
					showErrorMessage = alertas.error;
				}}
			</AlertasContext.Consumer>
			<BlockUiContext.Consumer>
				{blockUi => {
					onLoading = blockUi.handleLoading;
				}}
			</BlockUiContext.Consumer>
			<Row noGutters id="main-header">
				<Col>
					{/*<Row>*/}
					{/*	<Col className="alert alert-danger">*/}
					{/*		<strong>AVISO</strong>:O EcoGNRE está passando por instabilidade, nossa equipe técnica está trabalhando para normalizar o quanto antes.*/}
					{/*		Enquanto isto, a emissão pode ser realizada através do link: https://www.gnre.pe.gov.br:444/gnre/portal/GNRE_Principal.jsp*/}
					{/*	</Col>*/}
					{/*</Row>*/}

					<Row style={{ display: 'flex', 'justify-content': 'space-between', 'align-items': 'center', 'flex-wrap': 'wrap', padding: '10px', gap: '10px' }}>
						<Col style={{ flex: '0.7 1 0%', 'min-width': '100px' }}>
							<h1>Guias rejeitadas</h1>
						</Col>
						{/* <Col style={{ flex: '2 1 0%', 'min-width': '100px' }}>
							<NavLink
								href="https://auditor.econeteditora.com.br/validar-login"
								className="btn btn-secondary"
								target="_blank"
								style={{ padding: '4px 10px 1px 10px', fontSize: 'small' }}>
								Para gerar a <b>GNRE por Apuração</b>, favor auditar o arquivo TXT através do <b>Auditor Fiscal</b>
							</NavLink>
						</Col>
						<Col style={{ flex: '1 1 0%', 'min-width': '100px' }}>
							<NavLink
								href={urlHomo}
								className="btn btn-secondary"
								target="_blank"
								style={{ padding: '4px 10px 1px 10px', fontSize: 'small' }}>
								<>Verificar disponibilidade de emissão por UF </>
								<i className="fas fa-info-circle" />
							</NavLink>
						</Col> */}
					</Row>

					<Row noGutters>
						<Col className="singleHeaderHeight">
							<Row>
								<Col xs="auto p-0">
									<Button
										onClick={() => ModalEmissoesExclusao.current.openModal()}
										size="sm"
										color={`base-class ${
											showData.some(original => original.blSelected)
												? 'btn-info'
												: 'btn-secondary'
										}`}
										block
										disabled={
											!isSimulacao && !isPro
												? !showData.some(original => original.blSelected)
												: 'false'
										}>
										<i className="fas fa-trash-alt" /> Excluir
									</Button>
								</Col>
								<Col xs="auto p-0">
									<Button
										onClick={() => ModalEmissoesExclusaoTodos.current.openModal()}
										size="sm"
										color={`base-class ${
											showData.some(original => original.blSelected)
												? 'btn-danger'
												: 'btn-danger'
										}`}
										disabled={
											showData.length > 0
												? false
												: true
										}
										block
										>
										<i className="fas fa-trash-alt" /> Excluir Todas as Guias
									</Button>
								</Col>
							</Row>
						</Col>
						<Col xs="6" className="singleHeaderHeight mobile-buttons">
							{blShowPesquisaRapida ? (
								<PesquisaRapida
									value={strBusca}
									blShow={blShowPesquisaRapida}
									rawData={rawData}
									onUpdate={onUpdatePesquisaRapida}
								/>
							) : (
								<Container className="p-0">
									<Row>
										<Col />
										<Col xs="auto p-0">
											<Button
												onClick={() => {
													setBlFiltroAtivo(!blFiltroAtivo);
													setShowData(rawData);
													setStrBusca('');
												}}
												color="link">
												<i className="ecoico ecoico-filtro" />
											</Button>
										</Col>
										<Col xs="auto p-0">
											<Button
												onClick={() => {
													setBlShowPesquisaRapida(true);
													setBlFiltroAtivo(false);
												}}
												color="link">
												{strBusca ? (
													<i className="fas fa-search-plus" />
												) : (
													<i className="fas fa-search" />
												)}
											</Button>
										</Col>
									</Row>
								</Container>
							)}
						</Col>
					</Row>
				</Col>
			</Row>
			<Row noGutters>
				<Col>
					<ReactTable
						className="table-rejeitadas"
						ref={reactTable}
						data={showData}
						filterable={blFiltroAtivo}
						selectRow={{ mode: 'checkbox' }}
						columns={columns}
						showPagination={showData.length > 0}
						showPageSizeOptions={false}
						defaultSorted={[{ id: 'intNFE', desc: false }]}
						PaginationComponent={Pagination}
						childPaginationValue={childPaginationValue}
						SubComponent={row => renderDocumentosFiscais(row)}
						collapseOnDataChange={false}
						strTableInfo="Guias"
					/>
				</Col>
			</Row>
		</main>
	);
}

export default withRouter(Rejeitadas);
